export default { url : 'web.iciskare.com'}
// url : 'localhost/beil'
// export default { url : 'localhost/beil'}
